export const apartmentTypologyMapper = (data) => ({
    id: data.id,
    nameIt: data.nameIt,
})